/*
 * @Author: Kaiser
 * @Date: 2019-09-27 11:48:48
 * @Last Modified by: Kaiser
 * @Last Modified time: 2019-09-27 11:52:48
 * @Description: 错误码的报名单,在此名单内请求错误码不展示错误信息
 */
export var ERROR_CODE_WHITELIST = [];
export default ERROR_CODE_WHITELIST;
